import FileModel from './globals/FileModel';

export default class StandsMountingAttestationZipModel extends FileModel {
    static get path() {
        return '/backend/stands_mounting_attestation_zip';
    }
}